export default __webpack_public_path__ + "static/media/deadmanshandunchained.1644ec90.jpg";